
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { routerNames } from "@/common/js/const";
import Box from 'vux/src/components/box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import conf from "./../../config/base.js";

export default {
name: routerNames.OrderInvoiceFollow,
directives: {
TransferDom
},
components: {
Box,
Group,
Cell,
CellBox,
XHeader,
XButton,
XInput,
Previewer
},
data() {
return {
logoSrc: "",
qrMsg: "",
uniCode: "",
amount: "",
merchant: "HRT",
storeCode: "11021232",
mi: "",
disableInvoice: false,
imageSlide1: [
{
src: "",
msrc: "",
alt: "",
title: "",
pid: "image-one"
}
]
};
},
created() {},
activated() {
var $self = this;
console.log($self.$route.query);


$self.logoSrc = "/xforce/static/merch/" + $self.merchant + "/logo.jpg";
$self.imageSlide1[0].src =
"/xforce/static/merch/" + $self.merchant + "/help.png";
$self.imageSlide1[0].msrc =
"/xforce/static/merch/" + $self.merchant + "/help.png";
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
/**初始化的时候调用  类似于 ready */
mounted() {},
methods: {
tips() {
var $self = this;
$self.$refs.imageSlidePreviewer.show(0);
return false;
},

openInvoice(obj) {
var $self = this;
const unicode = {
dataMap: JSON.stringify({
uniCode: $self.uniCode,
amountWithTax: $self.amount,
unAccount: "wechat",
groupFlag: $self.merchant,
storeCode: $self.storeCode,
onlyOrder: 1
})
};
$self.disableInvoice = true;
$self.$webapi.queryOrderByUniCode(unicode).then(orderRes => {
$self.$clog(orderRes.data);
$self.disableInvoice = false;
if (orderRes.data.status == 1) {
$self.orderId = orderRes.data.orderId;
let date = orderRes.data.posDate;

var queryJSON = {
m: $self.merchant,
or: $self.uniCode,
p: $self.amount,
d: date,
b: $self.storeCode,
mi: $self.mi
};
$self.$router.replace({
path: "/orderInvoice/index",
query: queryJSON
});
} else if (orderRes.data.status == 302) {
window.location.href = orderRes.data.redirectUrl;
} else {
$self.orderId = -1;


this.$vux.alert.show({
title: "提示",
content: orderRes.data.msg,
onShow() {
console.log("Plugin: I'm showing");
},
onHide() {
console.log("Plugin: I'm hiding now");
}
});
}
});
}
}
};
